// extracted by mini-css-extract-plugin
export default {"Container":"CargoTypesSection_Container__b0OiW"};